import React, { useEffect } from "react";
import bannerImage from "../Images/DSVLL.jpg";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { Button, Dialog, Stack } from "@mui/material";
import { AppSettings } from "../AppSettings";

function SessionExpired() {
  const navigate = useNavigate();

  function handleCloase() {
    localStorage.removeItem("user-info-lpa");
    window.location.href = "/";
  }

  function handleRelogin() {
    localStorage.removeItem("user-info-lpa");
    window.location.replace(AppSettings.SSO_URL);
  }
  return (
    <>
      <Dialog
        open={true}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "95%",
              maxWidth: "480px", // Set your width here
            },
          },
        }}
      >
        <DialogTitle>{"Session Expired"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          <Stack spacing={2} pt={2}>
            <Alert severity="error">
              Your session has been expired. Please Re-login into the system.
              <>{}</> <p> </p>
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions>
          {" "}
          <Stack spacing={2} padding={2} direction="row">
            <Button type="submit" variant="outlined" onClick={handleCloase}>
              Close
            </Button>
            <Button type="submit" variant="contained" onClick={handleRelogin}>
              Re-Login
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SessionExpired;
